export default __webpack_public_path__ + "static/realWorldImg4-9a7a4515d557f31216fed6bdfb566a25.png";